import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled.div`
	height: fit-content;
	display: flex;
	flex-direction: column;
	gap: 50px;
	width: 100%;
`;

export const ContainerButton = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 6px;
	color: ${tokens.color_gray_dark};
	font-size: 18px;
	font-weight: 400;
`;

export const ContainerSkeleton = styled.div`
	div {
		height: 200px;
	}
`;
